module Meevo.Plugins.Client {
    "use strict";

    /**
    * NotesSection Section -- need aggregate model for handling functionality.
    */
    export class GiftCardSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Client> {

    }
}